import ManageTools from './ManageTools';
export default ManageTools;